import { cn } from "@/lib/utils";
import { type ReactNode } from "react";
import HeroBlock from "./hero-block";

type HeroSectionProps = {
  heading: string | ReactNode;
  body?: string | ReactNode;
  mobileBody?: string | ReactNode;
  button?: ReactNode;
  topComponent?: ReactNode;
  heroStyle?: string;
  headingStyle?: string;
  bodyStyle?: string;
  wrapperStyle?: string;
  bgStyle?: string;
};

const HeroSection = ({ ...props }: HeroSectionProps) => {
  return (
    <HeroBlock wrapperStyle={props.wrapperStyle} bgStyle={props.bgStyle}>
      <div className={cn("flex flex-col items-center gap-3 lg:gap-4", props.heroStyle)}>
        {props.topComponent}

        {typeof props.heading === "string" ? (
          <h1
            className={cn(
              "text-center text-5xl font-semibold text-gray-900 sm:text-7xl lg:text-balance lg:text-6xl lg:tracking-[0.015em]",
              props.headingStyle,
            )}
          >
            {props.heading}
          </h1>
        ) : (
          props.heading
        )}

        {props.body &&
          (typeof props.body === "string" ? (
            <p
              className={cn(
                "text-md px-2 text-center text-[#868C98]/90 lg:text-lg",
                props.bodyStyle,
              )}
            >
              {props.mobileBody ? (
                <>
                  <span className="block md:hidden">{props.mobileBody}</span>
                  <span className="hidden md:block">{props.body}</span>
                </>
              ) : (
                props.body
              )}
            </p>
          ) : (
            props.body
          ))}
      </div>

      {props.button}
    </HeroBlock>
  );
};

export default HeroSection;
